<template>
    <span class="notifications-count" v-show="count > 0">
        {{count}}
    </span>
</template>
<script>
import {actions, getters, setters} from './store';
export default {
    mounted:()=>{
        actions.init();
    },
    computed: {
        count:() => {
            return getters.count_unread();
        },
        // alerts:() => {
        //     return getters.alerts();
        // }
    },
     methods: {
        show: ()=> {
            setters.show(true);
        }
    }
   
}
</script>
<style scoped>

    .notifications-count {
        background: var(--color-error);
        color: var(--color-white);
        width: 20px;
        height: 20px;
        border-radius: 999em;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;        
    }

</style>